import { render, staticRenderFns } from "./blame_legend.vue?vue&type=template&id=05774b0d"
import script from "./blame_legend.vue?vue&type=script&lang=js"
export * from "./blame_legend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports